
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({ name: 'PathPlanning' })
export default class PathPlanning extends Vue {
    public pathPlanningUrl : string = process.env.VUE_APP_PATH_PLANNING_URL || "https://traxx-pathplanning.exxact-robotics.com/";
}
